export default __webpack_public_path__ + "static/mobile_dock-0e06c4ecce26e37aa090e589a96ebeac.png";